import { render, staticRenderFns } from "./ocrPages.vue?vue&type=template&id=2f640fde&scoped=true&"
import script from "./ocrPages.vue?vue&type=script&lang=js&"
export * from "./ocrPages.vue?vue&type=script&lang=js&"
import style0 from "./ocrPages.vue?vue&type=style&index=0&id=2f640fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f640fde",
  null
  
)

export default component.exports